import React, { useState, useEffect } from 'react';

import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import { Modal, Button } from 'react-bootstrap';

export default function StyledModal(props) {
  const [closed, setClose] = useState(false);

  return (
    <Modal
      show={props.show === true && closed === false}
      onHide={props.onClose || null}
      dialogClassName="empty-modal-dialog"
      backdropClassName="dimmed-backdrop"
      centered
    >
      <div className="empty-modal-wrapper">{props.children}</div>
    </Modal>
  );
}
